import { render, staticRenderFns } from "./BuildingEdit.vue?vue&type=template&id=3965e3e3"
import script from "./BuildingEdit.vue?vue&type=script&lang=ts"
export * from "./BuildingEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports